import {LinkInput} from '@local/types'
import {Button, Locale, Slideout} from '@local/ui/components'

import LogoNav from '@local/assets/svgs/logo-nav.svg'
import CloseSVG from '@local/assets/svgs/icon-close.svg'
import {HeaderList} from './HeaderList'

export interface HeaderSubMenuProps {
	isOpen: boolean
	onClickClose: () => void
	chapterLinks: Array<{
		cta: LinkInput
		tag?: string
	}>
	socialClubLinks: Array<LinkInput>
	getInTouchLinks: Array<LinkInput>
	className?: string
}

export const HeaderSubmenu = ({isOpen, onClickClose, chapterLinks, socialClubLinks, getInTouchLinks}:HeaderSubMenuProps) => {
	return (
		<Slideout
			isOpen={isOpen}
			onClickClose={onClickClose}
			className='bg-grey-4 text-white'>

			<div className='grid grid-cols-3 lg:grid-cols-2 items-center justify-between w-full py-16 lg:py-20'>
				<Button label='Menu Close' className='lg-max:hidden w-fit uppercase font-normal text-18' variant='underlined' onClick={onClickClose}><Locale>Menu</Locale></Button>
				<Button label='Menu Close' className='lg-max:hidden justify-self-end px-0 w-38 h-38' small variant='icon' onClick={onClickClose}><CloseSVG /></Button>

				<Button
					small
					variant='primary-transparent'
					onClick={onClickClose}
					label='Menu Close'
					className='lg:hidden px-16 aspect-square'>
					<CloseSVG />
				</Button>

				<Button className='lg:hidden justify-self-center' href='/' label='Homepage Link'>
					<LogoNav className='block h-32' />
				</Button>
			</div>

			<div className='flex flex-col w-full py-40 gap-40'>
				<HeaderList title='Chapters' links={chapterLinks} />
				<HeaderList title='Transformational Travel Experiences' links={socialClubLinks} />
			</div>
			<HeaderList title='Get in touch' links={getInTouchLinks} className='lg:mt-auto lg:pb-40' />
		</Slideout>
	)
}
